import { setErrorDialog, serverUrl, getheader, translateError} from "../../../store/api/CommonFunctions";
let dialogData = {
    status: 'show',
    arrayBtn: ['ok'],
    dialogTitle: 'دستور کار',
    dialogText: ' '
};
const showDialog = (dispatch, message, showText) => {
    if (message === "No Access") {
        dialogData.dialogText = "دسترسی مجاز نیست!‏";
    }
    else {
        dialogData.dialogText = showText;
    }
    dispatch({
        type: "SET_DIALOG",
        data: dialogData
    });
}
export function getMyCommands(data) {
    return dispatch => {
        dispatch({
            type: "GET_MY_COMMANDS",
            data: "PENDING"
        });
        fetch(serverUrl + "api/CommandAPI/GetMyCommands", {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data),
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    showDialog(dispatch, res.Message, "اشکال در دریافت لیست دستور کار ها");
                    res = null;
                }
                return dispatch({
                    type: "GET_MY_COMMANDS",
                    data: res
                });
            }).catch(e => {
                alert("اشکال در دریافت لیست دستور کار ها");
                dispatch({
                    type: "GET_MY_COMMANDS",
                    data: null
                });
            })
    }
}
export function getMyLastCommands(data, onGetData) {
    onGetData("PENDING");
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (!token || !sUrl) {
        onGetData([]);
        return;
    }
    fetch(sUrl + "api/CommandAPI/GetMyCommands", {
        headers: getheader(),
        method: "POST",
        body: JSON.stringify(data),
        cache: "default"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = {};
                res.Error = translateError(res.Message);
            }
            onGetData(res);
        }).catch(e => {
            console.log("[GET_LAST_COMMANDS]", e);
            onGetData({ Error: "اشکال در دریافت دستور کار ها" });
        })
}
export function getMyCommandsCount() {
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (!token || !sUrl) {
        return dispatch => {
            dispatch({
                type: "MY_COMMANDS_COUNT",
                data: 0
            });
        }
    }
    return dispatch => {
        dispatch({
            type: "MY_COMMANDS_COUNT",
            data: "PENDING"
        });
        fetch(sUrl + "api/CommandAPI/GetMyCommandsCount", {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "MY_COMMANDS_COUNT",
                    data: res
                });
            }).catch(e => {
                dispatch({
                    type: "MY_COMMANDS_COUNT",
                    data: null
                });
            })
    }
}
export function addNewCommand(data, fn) {
    return dispatch => {
        dispatch({
            type: "ADD_NEW_COMMAND",
            data: "PENDING"
        });
        fetch(serverUrl + "api/CommandAPI/AddNewCommand", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    showDialog(dispatch, res.Message, "اشکال در ثبت دستور کار")
                    res = null;
                }
                else if (!isNaN(res)) {
                    showDialog(dispatch, "", "ثبت دستور کار با موفقیت انجام شد");
                    if (fn) {
                        fn(res);
                    }
                }
                dispatch({
                    type: "ADD_NEW_COMMAND",
                    data: res
                });
            }).catch(e => {
                alert("اشکال در ثبت دستور کار");
                dispatch({
                    type: "ADD_NEW_COMMAND",
                    data: null
                });
            })
    }
}
export function editCommand(data) {
    return dispatch => {
        dispatch({
            type: "EDIT_COMMAND",
            data: "PENDING"
        });
        fetch(serverUrl + "api/CommandAPI/EditCommand", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error" || res.Message === "No Access") {
                    showDialog(dispatch, res.Message, "اشکال در ویرایش دستور کار");
                    res = null;
                }
                else {
                    showDialog(dispatch, "", "ویرایش با موفقیت انجام شد");
                }
                dispatch({
                    type: "EDIT_COMMAND",
                    data: res
                });
            }).catch(e => console.log("[EditCommand]", e));
    }
}
export function searchCommands(data) {
    return dispatch => {
        dispatch({
            type: "SEARCH_COMMAND",
            data: "PENDING"
        });
        dispatch({
            type:"COMMANDS_FILTER",
            data:data
        })
        fetch(serverUrl + "api/CommandAPI/SearchCommands", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "اشکال در بازیابی لیست");
                    res = null;
                }
                dispatch({
                    type: "SEARCH_COMMAND",
                    data: res
                });
            })
    }
}
export function deleteCommand(id, fn) {
    return dispatch => {
        dispatch({
            type: "DELETE_COMMAND",
            data: "PENDING"
        });
        fetch(serverUrl + "api/CommandAPI/DeleteCommand?id=" + id, {
            headers: getheader(),
            method: "GET"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    showDialog(dispatch, res.Message, "اشکال در حذف دستور کار");
                    res = null;
                }
                showDialog(dispatch, "", "حذف با موفقیت انجام شد");
                if (fn) {
                    fn();
                }
                return dispatch({
                    type: "DELETE_COMMAND",
                    data: res
                });
            }).catch(e => console.log("[DELETE_COMMAND]", e));
    }
}
export function getCommand(id, fn) {
    return dispatch => {
        if (id === -1) {
            return dispatch({
                type: "GET_COMMAND",
                data: null
            });
        }
        dispatch({
            type: "GET_COMMAND",
            data: "PENDING"
        });
        fetch(serverUrl + "api/CommandAPI/GetCommand?id=" + id, {
            headers: getheader(),
            method: "GET"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error" || res.Message === "No Access") {
                    showDialog(dispatch, res.Message, "اشکال در دریافت دستور کار");
                    res = null;
                }
                if (fn) {
                    fn(res);
                }
                return dispatch({
                    type: "GET_COMMAND",
                    data: res
                });
            }).catch(e => console.log("[GET_COMMAND]", e));
    }
}
export function getCommandByAttachmentID(attachmentID, attachmentType, fn) {
    return dispatch => {
        if (attachmentID === -1) {
            return dispatch({
                type: "GET_COMMAND",
                data: null
            });
        }
        dispatch({
            type: "GET_COMMAND",
            data: "PENDING"
        });
        fetch(serverUrl + `api/CommandAPI/GetCommandByAttachmentID?attachmentID=${attachmentID}&attachmentType=${attachmentType}`, {
            headers: getheader(),
            method: "GET"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error" || res.Message === "No Access") {
                    showDialog(dispatch, res.Message, "اشکال در دریافت دستور کار");
                    res = null;
                }
                if (fn) {
                    fn(res);
                }
                return dispatch({
                    type: "GET_COMMAND",
                    data: res
                });
            }).catch(e => console.log("[GET_COMMAND]", e));
    }
}
export function addNewMessage(data, fn) {
    return dispatch => {
        dispatch({
            type: "ADD_MESSAGE",
            data: "PENDING"
        });
        fetch(serverUrl + "api/CommandAPI/AddNewMessage", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error" || res.Message === "No Access") {
                    showDialog(dispatch, res.Message, "اشکال در دریافت دستور کار");
                    res = null;
                }
                else {
                    showDialog(dispatch, "", "ثبت پیام با موفقیت انجام شد");
                    if (fn) {
                        fn();
                    }
                }
            }).catch(e => console.log("[ADD_NEW_MESSAGE]", e));
    }

}
export function deleteMessage(id, fn) {
    return dispatch => {
        dispatch({
            type: "DELETE_MESSAGE",
            data: "PENDING"
        });
        fetch(serverUrl + "api/CommandAPI/DeleteMessage?id=" + id, {
            headers: getheader(),
            method: "DELETE"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    showDialog(dispatch, res.Message, "اشکال در حذف پیام");
                    res = null;
                }
                showDialog(dispatch, "", "حذف با موفقیت انجام شد");
                if (fn) {
                    fn();
                }
                return dispatch({
                    type: "DELETE_COMMAND",
                    data: res
                });
            }).catch(e => console.log("[DELETE_COMMAND]", e));
    }
}
export function doneCommand(id, fn) {
    return dispatch => {
        dispatch({
            type: "DONE_COMMAND",
            data: "PENDING"
        });
        fetch(serverUrl + "api/CommandAPI/DoneCommand?commandID=" + id, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    showDialog(dispatch, res.Message, "اشکال در انجام عملیات");
                    res = null;
                }
                else {
                    showDialog(dispatch, "", "عملیات با موفقیت انجام شد");
                    if (fn) {
                        fn();
                    }
                }
            })
    }
}
